<div class="page">
  <super-title [text]="'iscan.global.homePageTitle' | translate" [buttons]="buttons"></super-title>
  <super-tabs-xl class="d-flex justify-content-center mb-3" [tabs]="tabs" (activeTab)="changeTab($event)"
    [activeIndex]="tabsArrayXLActiveIndex"></super-tabs-xl>
  <i-table-v17 *ngIf="columns" [id]="'scanList'" [config]="tableConfigurations" [items]="items" [columns]="columns"
    [customActionManualReset]="true" [menu]="menu" (onSelectedRow)="modifyScan($event)"
    (pageChange)="onLazyLoad($event)">
  </i-table-v17>
</div>



<input type="file" #fileInput accept="application/pdf" (change)="uploadFile($event)" (cancel)="initButton()"
  style="display: none;" />


<p-dialog [visible]="openDialogDocumentLink" [style]="{ width: '60vw', minWidth: '60vw', maxWidth: '60vw' }"
  [header]="'iscan.infos.showPointsMeetingsLink' | translate" class="modal-actions"
  (visibleChange)="openDialogDocumentLink = false">
  <ng-container>
    <div>
      <i-table-v17 [id]="'documentLinkScan'" [config]="tableConfigurationsLinkScan" [items]="itemsDocumentLink"
        [columns]="columnsDocumentLink" [customActionManualReset]="true" (onSelectedRow)="showDetails($event)">
      </i-table-v17>
    </div>
  </ng-container>
</p-dialog>

<p-confirmDialog [header]="'confirm.confirmHeader' | translate" icon="pi pi-exclamation-triangle"
  [acceptLabel]="'Yes' | translate" [rejectLabel]="'No' | translate"></p-confirmDialog>